import type { EffectDefinition, EffectContext } from './types'

interface SmokeParticle {
  x: number
  y: number
  radius: number
  speed: number
  drift: number
  life: number
  maxLife: number
  opacity: number
  phase: number
}

function createSmoke(width: number, height: number): SmokeParticle {
  const life = 4 + Math.random() * 4
  return {
    x: Math.random() * width,
    y: height + 20 + Math.random() * 40,
    radius: 20 + Math.random() * 40,
    speed: 15 + Math.random() * 25,
    drift: (Math.random() - 0.5) * 30,
    life,
    maxLife: life,
    opacity: 0.04 + Math.random() * 0.06,
    phase: Math.random() * Math.PI * 2
  }
}

export const smoke: EffectDefinition = {
  id: 'smoke',
  name: 'Smoke',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 15000)
    const items: SmokeParticle[] = []
    for (let i = 0; i < Math.max(10, count); i++) {
      const p = createSmoke(ctx.width, ctx.height)
      p.y = Math.random() * ctx.height
      p.life = Math.random() * p.maxLife
      items.push(p)
    }
    return items
  },

  update(state: unknown, ctx: EffectContext) {
    const items = state as SmokeParticle[]
    const dt = ctx.deltaTime / 1000
    for (const p of items) {
      p.y -= p.speed * dt
      p.x += Math.sin(ctx.time / 1000 + p.phase) * p.drift * dt
      p.radius += 3 * dt
      p.life -= dt
      if (p.life <= 0) {
        Object.assign(p, createSmoke(ctx.width, ctx.height))
      }
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const items = state as SmokeParticle[]
    const { ctx: c } = ctx
    for (const p of items) {
      const fadeRatio = p.life / p.maxLife
      const alpha = p.opacity * fadeRatio

      const gradient = c.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.radius)
      gradient.addColorStop(0, `rgba(200, 200, 200, ${alpha})`)
      gradient.addColorStop(0.5, `rgba(180, 180, 180, ${alpha * 0.5})`)
      gradient.addColorStop(1, 'transparent')
      c.fillStyle = gradient
      c.fillRect(p.x - p.radius, p.y - p.radius, p.radius * 2, p.radius * 2)
    }
  }
}
